// Discrete "← Back to <list>" button for detail/edit pages. Goes in the
// PageHeader `actions` slot. The breadcrumb eyebrow already provides a
// clickable parent link, but users reported it wasn't obvious enough — so
// this is the explicit affordance on every detail/edit view.
import { Link } from '@tanstack/react-router';

export function BackButton({ to, label }: { to: string; label: string }) {
  return (
    <Link
      to={to}
      className="btn btn--ghost btn--sm"
      aria-label={`Back to ${label}`}
      style={{ display: 'inline-flex', alignItems: 'center', gap: '6px' }}
    >
      <svg
        width="14"
        height="14"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <polyline points="15 18 9 12 15 6" />
      </svg>
      Back
    </Link>
  );
}
